import React from 'react';
import './DatePicker.css';
import Utils from '../../lib/Utils';


class DatePicker extends React.Component {
  state = {
    display:false,
    currentDate: new Date(),
    showDate: new Date(),
    position: {x:0,y:0},
    target:null,
    onChange:null
  };

  open = (target, onChange) => {
    let bnd = target.getBoundingClientRect();
    let date = Utils.YmdToDateObject(target.value);
    if (!date) {
      date = new Date();
    }
    this.setState({
      display:true,
      currentDate:date,
      showDate: date,
      position:{x:bnd.x, y:bnd.y+bnd.height},
      target:target,
      onChange:onChange,
    });
  }

  onClickBack = e => {
    if (!e.target.classList.contains('DatePicker')) return;
    this.setState({
      display:false,
      target:null
    })
  }
  onClickCalendar = e => {
    if (!e.target.classList.contains('DatePicker-date')) return;
    let target = this.state.target;
    target.value = e.target.dataset.date;
    target.dispatchEvent(new Event('change', {bubbles:true}));
    if (typeof this.state.onChange === 'function') this.state.onChange(e.target.dataset.date);
    this.setState({
      display:false,
      target:null
    });
  }
  onChangeYear = (e) => {
    let showDate = this.state.showDate;
    showDate.setFullYear(e.target.value);
    this.setState({
      showDate: showDate
    });
  }
  onChangeMonth = (e) => {
    let showDate = this.state.showDate;
    showDate.setMonth(parseInt(e.target.value,10) -1);
    this.setState({
      showDate: showDate
    });
  }
  onClickPrevMonthBtn = () => {
    let date = new Date(this.state.showDate);
    date.setMonth(date.getMonth()-1);
    this.setState({
      showDate: date
    });
  }

  onClickNextMonthBtn = () => {
    let date = new Date(this.state.showDate);
    date.setMonth(date.getMonth()+1);
    this.setState({
      showDate: date
    });
  }

  render() {
    let fullYear = this.state.showDate.getFullYear();
    let years = [];
    years = [-5,-4,-3,-2,-1].reduce((c, y)=>{c.push(fullYear+y); return c}, years);
    years.push(fullYear);
    years = [1,2,3,4,5].reduce((c, y)=>{c.push(fullYear+y); return c}, years);

    let dates = [];
    let firstDate = new Date(this.state.showDate);
    firstDate.setDate(1);
    firstDate.setDate(-(firstDate.getDay()-1));
    let lastDate = new Date(this.state.showDate);
    lastDate.setDate(1);
    lastDate.setMonth(lastDate.getMonth()+1);
    lastDate.setDate(0);
    lastDate.setDate(lastDate.getDate() + (7-lastDate.getDay()));
    let d = new Date(firstDate);
    let w = null;
    while (true) {
      if (d.getTime() >= lastDate.getTime()) {
        dates.push(w);
        break;
      }
      if (d.getDay() === 0) {
        if (w) dates.push(w);
        w = [];
      }
      w.push({
        year: d.getFullYear(),
        month: d.getMonth()+1,
        date: d.getDate(),
        day: d.getDay(),
        text: d.getFullYear()+'-'+('00'+(d.getMonth()+1)).slice(-2)+'-'+('00'+d.getDate()).slice(-2)
      });
      d.setDate(d.getDate()+1);
    }
    let currentMonth = this.state.showDate.getMonth()+1;
    let currentDate = Utils.getHyphenationDate( this.state.currentDate);
    let todate = Utils.getHyphenationDate();
    //console.log(dates)

    return (
      <div className="DatePicker" style={{display:this.state.display?'block':'none'}} onClick={this.onClickBack}>
        <div className="window" style={{left:this.state.position.x+'px', top:this.state.position.y+'px'}}>
          <div className="DatePicker-header">
            <div className="DatePicker-leftArrowBtn" onClick={this.onClickPrevMonthBtn}>&lt;</div>
            <div className="DatePicker-yearMonth">
              <select className="DatePicker-yearSelect" value={this.state.showDate.getFullYear()} onChange={this.onChangeYear} ref={ref=>{this.yearSelect=ref;}}>
                {
                  years.map(y=>{return <option key={y}>{y}</option>})
                }
              </select>
              <span className="DatePicker-yearSelect-text">年</span>
              <select className="DatePicker-monthSelect" value={this.state.showDate.getMonth()+1} onChange={this.onChangeMonth}>
                {
                  [1,2,3,4,5,6,7,8,9,10,11,12].map(m=>{return <option key={m}>{m}</option>})
                }
              </select>
              <span className="DatePicker-yearSelect-text">月</span>
            </div>
            <div className="DatePicker-rightArrowBtn" onClick={this.onClickNextMonthBtn}>&gt;</div>
          </div>
          <div className="DatePicker-calendar" onClick={this.onClickCalendar}>
            <div className="DatePicker-week DatePicker-days">
                <div className="DatePicker-day" data-day="0">日</div>
                <div className="DatePicker-day">月</div>
                <div className="DatePicker-day">火</div>
                <div className="DatePicker-day">水</div>
                <div className="DatePicker-day">木</div>
                <div className="DatePicker-day">金</div>
                <div className="DatePicker-day" data-day="6">土</div>
            </div>
            {
              dates.map((w, i)=>{
                return (<div className="DatePicker-week" key={i}>
                  {
                    w.map((d,i)=>{
                      return (<div className={"DatePicker-date" + (d.month === currentMonth ? ' DatePicker-currentMonth' : '') + (d.text === todate ? ' DatePicker-todate' : '') + (d.text === currentDate ? ' DatePicker-currentDate' : '')} data-date={d.text} data-day={d.day} key={d.date}><span className="DatePicker-dateCircle">{d.date}</span></div>)
                    })
                  }
                </div>)
              })
            }
          </div>
        </div>
      </div>
    )
  }
}
export default DatePicker;